var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-tab",attrs:{"id":_vm.id,"role":"tabpanel","tabindex":"0","aria-labelledby":_vm.labelledBy,"hidden":!_vm.dActive}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }